export const students = {
  youDoNotHaveAnyStudentsYet: "You don't have any students yet",
  addStudentsManuallyOrHaveStudents:
    "Add students manually or have students easily sign up with a class code!",
  addStudent: "Add student",
  moreActions: "More actions",
  searchForStudent: "Search for student",
  exportData: "Export Data",
  sendTransactionsToMoreThan:
    "Send transactions to more than one student by selecting them on the list",
  mathOn: "Math On",
  turnOnOrTurnOffMathOption:
    "Turn ON or turn OFF math option to more than one student by selecting them on the list",
  dontWantStudentsToHaveToAddOrSubtractTheirTransactions:
    "Don't want students to have to add or subtract their transactions? Uncheck them from the list below.",
  studentsInfo: "Student info",
  classCode: "Class code",
  sendBonuses: "Send bonuses",
  sendFines: "Send fines",
  sendPaychecks: "Send paychecks",
  sendExpenses: "Send expenses",
  studentsSelected_one: "{{count}} student selected",
  studentsSelected_other: "{{count}} students selected",
  numberOfStudentsSelected: "{{quantity}} students selected",
  scrollActionsLeft: "Scroll actions left",
  scrollActionsRight: "Scroll actions right",
  student: "Student",
  job: "Job",
  jobsLabel: "Job(s):",
  balance: "Balance",
  checking: "Checking",
  pending: "Pending",
  savings: "Savings",
  showCheckingAndSavingsTotals: "Show checking & savings",
  hideCheckingAndSavingsTotals: "Hide checking & savings",
  delete: "Delete",
  currentBalance: "Current balance",
  sendTransaction: "Send transaction",
  sendTransactionOrStoreCharge: "Send transaction or store charge",
  goTo: "Go to",
  studentSignUp: "Student <underline>Sign-up</underline>",
  toEnterYourClassCode: "to <underline>create</underline> an account",
  subtitleClassCode:
    "If you students already have an account, they do not need a class code. They can log in at {{url}}",
  addToClass: "Add to class",
  firstName: "First name",
  lastName: "Last name",
  userName: "User name",
  setPassword: "Set password",
  password: "Password",
  addAnotherStudent: "Add another student",
  removeStudentRow: "Remove student",
  gridView: "Grid view",
  listView: "List view",
  areYoutSure: "Are you sure you want to close?",
  enteredInformationWillBeLost: "Entered information will be lost",
  value: "Value",
  studentFirst: "Student first name",
  studentLast: "Student last name",
  studentAscending: "Student ascending",
  studentDescending: "Student descending",
  studentLastAscending: "Student last name ascending",
  studentLastDescending: "Student last name descending",
  studentFirstAscending: "Student first name ascending",
  studentFirstDescending: "Student first name descending",
  firstNameAZ: "Student first name [A-Z]",
  firstNameZA: "Student first name [Z-A]",
  lastNameAZ: "Student last name [A-Z]",
  lastNameZA: "Student last name [Z-A]",
  valueAscending: "Value ascending",
  valueDescending: "Value descending",
  balanceAscending: "Balance ascending",
  balanceDescending: "Balance descending",
  checkingsAscending: "Checkings Ascending",
  checkingsDescending: "Checkings Descending",
  savingsAscending: "Savings Ascending",
  savingsDescending: "Savings Descending",
  noJobs: "No jobs",
  seeStudentsProfile: "See student's profile",
  transactionsSentSuccessfully: "Transactions sent successfully",
  selectUpTo20Transactions: "Select up to 20 transactions",
  selectAtLeaseOneTransaction: "Select at least one transaction",
  addNewStudent: "Add new student",
  noStudentsAddedYet: "No students added yet",
  searchForStudentNameOrAddNew: "Search for student name or add new",
  studentAddedSuccessfully: "Student added successfully",
  studentsAddedSuccessfully: "Students added successfully",
  addAllStudents: "Add all students",
  userNamesHaveToBeUnique: "User names have to be unique",
  clickToFillOut: "Click to fill out",
  youNeedToAddAtLeastOneStudent: "You need to add at least one student",
  importStudents: "Import students",
  importStudentsDescription:
    "Upload an Excel file to import your students. Start by downloading our upload template <Link>here.</Link>",
  selectFileToUpload: "Select file to upload",
  clearSelectedFile: "Clear selected file",
  listOfStudentsHasBeenImported: "List of students has been imported",
  processing: "Processing...",
  importFailed: "Import failed:",
  notAllowedDataOrEmptyCellsInRows: "Not allowed data, or empty cells in rows",
  importHasBeenCompleted: "Import has been completed",
  importUpdates: "Import updates",
  somethingWentWrong:
    "Something went wrong with the importing, refresh site to check errors",
  somethingWentWrongTryAgain: "Something went wrong, please try again later",
  resetBalance: "Reset balance",
  removeFromClass: "Remove from class",
  deleteStudent: "Delete student",
  areYouSureYouWantToRemoveStudentFromClass:
    "Are you sure you want to remove {{student}} from {{classname}}?",
  areYouSureYouWantToRemoveTheseStudentsFromTheClass:
    "Are you sure you want to remove these students from the class {{classname}}?",
  areYouSureYouWantToResetBalance:
    "Are you sure you want to reset {{student}}'s balance?",
  areYouSureYouWantToResetBalancesForClass:
    "Are you sure you want to reset balances for class {{classname}}?",
  areYouSureYouWantToDeleteStudent:
    "Are you sure you want to delete {{student}}?",
  areYouSureYouWantToDeleteStudents:
    "Are you sure you want to delete students?",
  balanceHasBeenSuccessfullyReset:
    "{{student}} balance has been successfully reset",
  studentsBalancesHasBeenSuccessfullyReset:
    "Students balance have been successfully reset",
  resetBalanceFailed:
    "Something went wrong while resetting balances, please try again",
  resetBalanceStatusUnknown:
    "Couldn't confirm the reset status - check current balances or try again",
  studentHasBeenSuccessfullyDeleted:
    "{{student}} has been successfully deleted",
  studentHasBeenSuccessfullyRemovedFromClass:
    "{{student}} has been successfully removed from class ",
  studentHaveBeenSuccessfullyDeleted: "Students have been successfully deleted",
  studentsHaveBeenSuccessfullyRemovedFromClass:
    "Students have been successfully removed from class ",
  thisActionCannotBeUndone:
    "This action cannot be undone. All student data will be permanently deleted for you and all other teachers.",
  youWillRemoveAllOfStudentsInThisClassExcept:
    "You will remove all of students in this class except:",
  youWillRemoveTheFollowingStudents: "You will remove the following students:",
  youWillRemoveAllOfStudentsFromClass:
    "You will remove all of students from class",
  youWillDeleteAllOfStudentsInThisClassExcept:
    "You will <strong>permanently delete selected students from the ClassBank system</strong> except:",
  youWillDeleteTheFollowingStudents: "You will delete the following students:",
  youWillDeleteAllOfStudentsFromClass:
    "You will <strong>permanently delete all of students from the ClassBank system.</strong>. This action is not intended for removing students from a class!",
  youWillResetBalanceAllOfStudentsInThisClassExcept:
    "You will reset balance all of students in this class except:",
  youWillResetBalanceTheFollowingStudents:
    "You will reset balance for the following students:",
  youWillResetBalanceAllOfStudentsFromClass:
    "You will reset balance for all of students from class",
  descriptionUpgradeAddAllStudents:
    "Add all students is a feature included in the 'School Subscription'. Learn more about our <Link>paid plans here</Link>. Upgrade to school to unlock this feature.",
  copyClassCode: "Copy class code",
  classCodeCopied: "Class code copied",
  clickToShowClassCode: "Click to show class code dialog",
  failedToCopyClassCode: "Failed to copy class code",
  copied: "Copied!",
  typeDeleteToConfirm: "Type <bold>\"Delete\"</bold> to confirm",
  deleteConfirmationPlaceholder: "Type Delete here",
}
